import { render, staticRenderFns } from "./SmartTableFooter.vue?vue&type=template&id=428a2b53&scoped=true"
import script from "./SmartTableFooter.vue?vue&type=script&lang=js"
export * from "./SmartTableFooter.vue?vue&type=script&lang=js"
import style0 from "./SmartTableFooter.vue?vue&type=style&index=0&id=428a2b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a2b53",
  null
  
)

export default component.exports